/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ShopAgreementCreateRequest = {
    name?: string;
    consentType?: ShopAgreementCreateRequest.consentType;
    description?: string;
    remark?: string;
};
export namespace ShopAgreementCreateRequest {
    export enum consentType {
        INSTALLMENT = 'INSTALLMENT',
        PDPA = 'PDPA',
    }
}

